//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util from '@/utils/table.js';
import * as api from '@/api/protocols';
import { getProtoList, deleteProto, disableProto as _disableProto, seizedInfo, protocolInventoryDc, countProtocolInventoryDc, BASE, BASE_PATH } from '@/api/protocol';
import { getRoleButtonConfigInfo } from '@/api/permissions';
import { getChilComList, getProductList } from '@/api/baseDate';
import List_obj from './list_obj.js';
export default {
  // name: 'ProtocolView',
  name: 'protocoSearch',
  inject: ['reload'],
  data: function data() {
    return {
      protocolInventoryDc: true,
      baseUrl: BASE + BASE_PATH,
      formData: {
        endorValidDate: '',
        //批单生效日
        protocolNo: '' //op协议号

      },
      loading: true,
      dialogStatus: '',
      protocolStatusList: List_obj.protocolStatusList,
      dialogFormVisible: false,
      protoForm: {
        insurancecompanyCode: '',
        // 保险公司code
        insuranceCompanyName: '',
        // 保险公司name
        protocol2Code: '',
        protocolNo: '',
        handler1Code: '',
        currency: '',
        agreementStartDate: '',
        agreementEndDate: '',
        appliName: '',
        insuredName: '',
        riskCode: '',
        protocolStatus: '00',
        auditStatus: '0'
      },
      agreementStartDate: '',
      agreementEndDate: '',
      showFlag: false,
      protocolNo: '',
      userId: '',
      total: 0,
      pageShow: false,
      protoInfoList: [],
      // 编辑界面数据
      protocolList: [],
      // 分支机构集合
      productList: [],
      // 产品名称
      pagination: {
        currentPage: 1,
        // 当前页
        pageNumber: 1,
        pageSize: 10,
        // 展示条数
        pageSizes: [10, 25, 50, 100],
        // 展示条数列表
        totalItems: 0 // 总条数

      },
      menuList: [],
      //按钮配置数据集合
      deleteFlag: true,
      modifyFlag: true,
      copyFlag: true,
      correctFlag: true
    };
  },
  watch: {
    '$route': 'getSearchData'
  },
  mounted: function mounted() {
    // const  icompanyCode1 = JSON.parse(sessionStorage.getItem('newinsurancecompanyCode'))
    // const  icompanyName2 = JSON.parse(sessionStorage.getItem('newinsurancecompanyName'))
    // this.ruleForm.insurancecompanyCode = icompanyCode1
    // this.ruleForm.insuranceCompanyName = icompanyName2
    // console.log('保险公司code',icompanyCode1)
    // console.log('保险公司name',icompanyName2)
    this.searchProto(1);
  },
  created: function created() {
    var _this = this;

    var companyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || '';
    var companyName = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyName || '';
    this.protoForm.insurancecompanyCode = companyCode;
    this.protoForm.insuranceCompanyName = companyName;
    console.log('保险公司Code', this.protoForm.insurancecompanyCode);
    console.log('保险公司Name', this.protoForm.insuranceCompanyName);
    console.log('保险公司code1111', companyCode);
    this.userId = this.$store.state.user.userinfo.userId; // 获取保险公司下分支机构集合

    getChilComList({
      'insuranceCompanyCode': companyCode
    }).then(function (res) {
      _this.protocolList = res;
    }); // 产品数据下拉

    getProductList({
      'insuranceCompanyCode': companyCode
    }).then(function (res) {
      _this.productList = res;
    });
    var requestPage = 'protocol-view';
    console.log('requestPage' + requestPage);
    getRoleButtonConfigInfo({
      'requestPage': requestPage
    }).then(function (res) {
      console.log('------res------' + res);

      if (res.menuList != null && res.menuList.length > 0) {
        _this.menuList = res.menuList;

        for (var i = 0; i < _this.menuList.length; i++) {
          if (_this.menuList[i].buttonType == 'modify') {
            if (_this.menuList[i].startUsing == '1') {
              _this.modifyFlag = false;
            } else {
              _this.modifyFlag = false;
            }
          } else if (_this.menuList[i].buttonType == 'correct') {
            if (_this.menuList[i].startUsing == '1') {
              _this.correctFlag = false;
            } else {
              _this.correctFlag = false;
            }
          } else if (_this.menuList[i].buttonType == 'copy') {
            if (_this.menuList[i].startUsing == '1') {
              _this.copyFlag = false;
            } else {
              _this.copyFlag = false;
            }
          } else if (_this.menuList[i].buttonType == 'delete') {
            if (_this.menuList[i].startUsing == '1') {
              _this.deleteFlag = false;
            } else {
              _this.deleteFlag = false;
            }
          }
        }
      } else {
        _this.modifyFlag = true;
        _this.correctFlag = true;
        _this.copyFlag = true;
        _this.deleteFlag = true;
      }
    });
  },
  methods: {
    getSearchData: function getSearchData() {
      this.query('protoForm');
    },
    cancel: function cancel() {
      console.log("取消");
      this.showFlag = false;
      this.formData.endorValidDate = '';
    },
    compareDate: function compareDate(date1, date2) {
      var oDate1 = new Date(date1);
      var oDate2 = new Date(date2);

      if (oDate1.getTime() == oDate2.getTime()) {
        return true;
      } else if (oDate1.getTime() > oDate2.getTime()) {
        return true;
      } else {
        return false;
      }
    },
    confirm: function confirm() {
      var _this2 = this;

      console.log('点击确定');
      console.log('批单生效日：' + this.formData.endorValidDate);
      var newAgreementEndDate = new Date(this.agreementEndDate);
      newAgreementEndDate.setDate(newAgreementEndDate.getDate() + 1);
      var addAgreementEndDate = this.formatDateTime(newAgreementEndDate);
      console.log('协议止期加1：' + addAgreementEndDate);
      var firstFlag = this.compareDate(this.formData.endorValidDate, this.agreementStartDate);
      var secondFlag = this.compareDate(addAgreementEndDate, this.formData.endorValidDate);

      if (this.formData.endorValidDate != '' && this.formData.endorValidDate != null) {
        if (firstFlag && secondFlag) {
          //校验 当已经存在生效的批单时再次新增批单时批单生效日需要大于等于之前的批单生效日
          api.getEndorseValidData({
            'protocolNo': this.protocolNo
          }).then(function (res) {
            if (res.length > 0) {
              for (var i = 0; i < res.length; i++) {
                if (res[i].endorValidDate == null) {
                  _this2.correct();

                  _this2.showFlag = false;
                  break;
                } else {
                  var flag = _this2.compareDate(_this2.formData.endorValidDate, res[i].endorValidDate);

                  if (!flag) {
                    _this2.$message({
                      message: '批单生效日期应该大于等于已生效批单的批单生效日',
                      type: 'warning'
                    });

                    return;
                  } else {
                    _this2.correct();

                    _this2.showFlag = false;
                  }
                }
              }
            } else {
              _this2.correct();

              _this2.showFlag = false;
            }
          });
        } else {
          this.$message({
            message: '批单生效日期应该在协议保险期间内',
            type: 'warning'
          });
          return;
        }
      } else {
        this.$message({
          message: '请选择【批单生效日期】',
          type: 'warning'
        });
        return;
      }
    },
    correct: function correct() {
      this.$router.push({
        path: "/protocols/protocolsInserts/".concat(this.protocolNo, "/").concat(this.formData.endorValidDate, "/edits")
      });
    },

    /**
     * 新增协议
     */
    addProtoInfo: function addProtoInfo() {
      this.$router.push({
        name: 'protocolInsert'
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.searchProto(1);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.pageNumber = val;
      this.searchProto(val);
    },
    formatDateTime: function formatDateTime(date) {
      if (date != '') {
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        var d = date.getDate();
        d = d < 10 ? '0' + d : d;
        return y + '-' + m + '-' + d;
      } else {
        return '';
      }
    },

    /**
     * 获取下一年
     */
    getNextYearTime: function getNextYearTime() {
      var newdate = new Date();
      newdate = newdate.setFullYear(newdate.getFullYear() + 1);
      var aa = new Date(newdate);
      return aa;
    },
    //点击查询
    query: function query(formName) {
      var _this3 = this;

      // debugger
      this.protoForm.protocolNo = this.protoForm.protocolNo.trim();

      if (this.protoForm.protocolApplyNo) {
        this.protoForm.protocolApplyNo = this.protoForm.protocolApplyNo.trim();
      } // 表单验证


      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.pagination.pageNumber = 1;
          _this3.pagination.pageSize = 10;

          _this3.searchProto(1);
        } else {
          _this3.cofirmBox('请选择机构！', '温馨提示');

          return false;
        }
      });
    },

    /**
     * 查询协议信息
     */
    searchProto: function searchProto(pageNumber) {
      var _this4 = this;

      this.loading = true;
      var agreementStartDate = '';

      if (this.protoForm.agreementStartDate) {
        agreementStartDate = this.formatDateTime(this.protoForm.agreementStartDate) + ' 00:00:00';
      }

      var agreementEndDate = '';

      if (this.protoForm.agreementEndDate) {
        agreementEndDate = this.formatDateTime(this.protoForm.agreementEndDate) + ' 00:00:00';
      }

      if (this.protoForm.agreementStartDate && this.protoForm.agreementEndDate) {
        if (this.protoForm.agreementStartDate > this.protoForm.agreementEndDate) {
          this.$message({
            type: 'warning',
            message: 'OP协议生效起期不能晚于生效止期'
          });
          this.loading = false;
          return false;
        }
      }

      this.pagination.currentPage = pageNumber; // 绑定当前页，比如第二次点击查询时，当前页变成1

      var para = {
        protocol2Code: this.protoForm.protocol2Code || '',
        protocolNo: this.protoForm.protocolNo || '',
        protocolApplyNo: this.protoForm.protocolApplyNo || '',
        handler1Code: this.protoForm.handler1Code || '',
        currency: this.protoForm.currency || '',
        agreementStartDate: agreementStartDate || '',
        agreementEndDate: agreementEndDate || '',
        appliName: this.protoForm.appliName || '',
        insuredName: this.protoForm.insuredName || '',
        riskCode: this.protoForm.riskCode || '',
        protocolStatus: this.protoForm.protocolStatus || '00',
        auditStatus: '0',
        pageNo: pageNumber,
        pageSize: this.pagination.pageSize,
        type: '0',
        insurancecompanyCode: this.protoForm.insurancecompanyCode,
        insuranceCompanyName: this.protoForm.insuranceCompanyName
      };
      console.log(para);
      getProtoList(para).then(function (res) {
        _this4.loading = false;

        if (res.totalCount > 0) {
          _this4.pageShow = true;
        } else {
          _this4.pageShow = false;
        }

        _this4.protoInfoList = res.content; // 列表数据

        _this4.pagination.totalItems = res.totalCount; // 绑定总条数

        var formatter = new Intl.DateTimeFormat('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });

        if (_this4.protoInfoList) {
          for (var i = 0; i < _this4.protoInfoList.length; i++) {
            // 协议生效日期省去时分秒
            if (_this4.protoInfoList[i].agreementStartDate != undefined && _this4.protoInfoList[i].agreementStartDate != null) {
              _this4.protoInfoList[i].agreementStartDate = formatter.format(new Date(_this4.protoInfoList[i].agreementStartDate)).replace(/\//g, '-');
            }

            if (_this4.protoInfoList[i].agreementEndDate != undefined && _this4.protoInfoList[i].agreementEndDate != null) {
              _this4.protoInfoList[i].agreementEndDate = formatter.format(new Date(_this4.protoInfoList[i].agreementEndDate)).replace(/\//g, '-');
            }
          }
        }
      }).catch(function (err) {
        console.log(err.message); // this.$message.error('保存失败，请联系管理员。')

        _this4.loading = false;
      });
    },

    /**
     * 重置
     */
    restProto: function restProto() {
      this.protoForm = {
        protocol2Code: '',
        protocolNo: '',
        handler1Code: '',
        currency: '',
        agreementStartDate: '',
        agreementEndDate: '',
        appliName: '',
        insuredName: '',
        riskCode: '',
        protocolStatus: '00',
        auditStatus: '1',
        pageNo: '1',
        pageSize: '10'
      };
      var companyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || '';
      var companyName = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyName || '';
      this.protoForm.insurancecompanyCode = companyCode;
      this.protoForm.insuranceCompanyName = companyName;
    },

    /**
     * 修改协议
     * @param row 当前对象
     * @param type 操作类型
     */
    viewAndupdateProto: function viewAndupdateProto(row, type) {
      // console.log('row:' + row + 'type:' + type)
      if (type === 'view') {
        this.$router.push({
          path: "/protocol/protocoView/".concat(row.protocolNo, "/").concat(type)
        });
      } else {
        var userId = this.$store.state.user.userinfo.userId;

        if (type === 'edit' && row.operatorCode && row.operatorCode !== userId) {
          this.$message({
            type: 'warning',
            message: '该协议由' + row.operatorName + '处理'
          });
        } else if (type === 'copy') {
          console.log('row.protocolNo', row.protocolNo);
          this.$router.push({
            path: "/protocol/protocoCopy/".concat(row.protocolNo, "/").concat(type)
          });
        } else {
          this.$router.push({
            path: "/protocol/protocoUpdate/".concat(row.protocolNo, "/").concat(type)
          });
        }
      }
    },

    /**
     * 删除协议信息
     * @row 当前对象信息
     */
    deleProto: function deleProto(row) {
      var _this5 = this;

      var userId = this.$store.state.user.userinfo.userId;

      if (row.operatorCode && row.operatorCode !== userId) {
        this.$message({
          type: 'warning',
          message: '该协议由' + row.operatorName + '处理'
        });
      } else {
        this.$confirm('是否要删除该协议?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          deleteProto({
            'protocolNo': row.protocolNo
          }).then(function (res) {
            if (res.rtnCode === '0000') {
              _this5.$message({
                type: 'success',
                message: '该协议删除成功'
              });
            } else {
              _this5.$message({
                type: 'warning',
                message: res.rtnMsg
              });
            }

            _this5.reload();
          });
        }).catch(function () {
          _this5.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      }
    },
    //协议清单导出
    protocolListExport: function protocolListExport() {
      var _this6 = this;

      var agreementStartDate = '';

      if (this.protoForm.agreementStartDate) {
        agreementStartDate = this.formatDateTime(this.protoForm.agreementStartDate) + ' 00:00:00';
      }

      var agreementEndDate = '';

      if (this.protoForm.agreementEndDate) {
        agreementEndDate = this.formatDateTime(this.protoForm.agreementEndDate) + ' 00:00:00';
      }

      var data = {
        //保险公司代码
        insuranceCompanyCode: this.protoForm.insurancecompanyCode,
        //保险公司名称
        insuranceCompanyName: this.protoForm.insuranceCompanyName,
        //分支机构
        protocol2Code: this.protoForm.protocol2Code || '',
        //OP协议号码
        protocolNo: this.protoForm.protocolNo || '',
        //平台协议申请号
        protocolApplyNo: this.protoForm.protocolApplyNo || '',
        //归属业务员
        handler1Code: this.protoForm.handler1Code || '',
        //协议状态
        protocolStatus: this.protoForm.protocolStatus || '',
        //OP协议生效日期从
        agreementStartDate: agreementStartDate || '',
        // OP协议生效日期到
        agreementEndDate: agreementEndDate || '',
        //投保人名称
        appliName: this.protoForm.appliName || '',
        //被保险人名称
        insuredName: this.protoForm.insuredName || '',
        //产品名称
        riskCode: this.protoForm.riskCode || '',
        auditStatus: '0',
        type: '0'
      };
      countProtocolInventoryDc(data).then(function (res1) {
        if (res1.resultCode === '0000') {
          if (res1.resultObj > 1000) {
            _this6.$message({
              message: '导出数据数量大于1000条,不允许导出，请改变查询条件后重新导出',
              type: 'error'
            });
          } else if (res1.resultObj == 0) {
            _this6.$message({
              message: '导出数据数量为0,不允许导出，请改变查询条件后重新导出',
              type: 'error'
            });
          } else {
            protocolInventoryDc(data).then(function (res) {
              var blob = new Blob([res], {
                type: 'application/vnd.ms-excel'
              }); // 兼容ie

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, '协议清单.xlsx');
              } else {
                var url = window.URL.createObjectURL(blob);
                var link = document.createElement('a'); // 创建a标签

                link.href = url;
                link.download = '协议清单.xlsx'; // 重命名文件

                link.click();
                window.URL.revokeObjectURL(url); // 释放内存
              }
            });
          }
        }
      });
    },

    /**
     * 批改协议信息
     * @row 当前对象信息
     */
    endorseProto: function endorseProto(row) {
      var _this7 = this;

      this.protocolNo = row.protocolNo;
      this.formData.endorValidDate = '';
      this.agreementStartDate = row.agreementStartDate;
      this.agreementEndDate = row.agreementEndDate;
      console.log(this.agreementEndDate);
      console.log(row, '513行');
      console.log(row.endorseApplyCode, '514行');
      this.loading = true;
      api.initEndorse({
        'protocolNo': row.protocolNo
      }).then(function (res) {
        console.log('点批改时调接口：', res);

        if (res.rtnCode != '0000') {
          _this7.loading = false;

          _this7.$message({
            message: '该协议存在未审核通过的批单，不允许进行批改',
            type: 'warning'
          });

          return;
        } else {
          _this7.loading = false;
          _this7.showFlag = true;
        }
      });
    },

    /**
     * 解绑操做
     * @row 当前对象信息
     */
    removeProto: function removeProto(row) {
      var _this8 = this;

      var userId = this.$store.state.user.userinfo.userId;

      if (row.operatorCode !== userId) {
        this.$message({
          type: 'warning',
          message: '该协议由' + row.operatorName + '处理'
        });
      } else {
        this.$confirm('是否要解绑该协议处理人?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var info = {
            'protocolNo': row.protocolNo,
            'operatorCode': _this8.$store.state.user.userinfo.userId,
            'operatorName': _this8.$store.state.user.userinfo.userName,
            'flag': '2'
          };
          seizedInfo(info).then(function (res) {
            if (res.rtnCode === '0000') {
              _this8.$message({
                type: 'success',
                message: '解绑该协议处理人成功'
              });
            } else {
              _this8.$message({
                type: 'warning',
                message: res.rtnMsg
              });
            }

            _this8.reload();
          });
        }).catch(function () {
          _this8.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      }
    },

    /**
     * 禁用协议信息
     * @row 当前对象信息
     */
    disableProto: function disableProto(row) {
      var _this9 = this;

      this.$confirm('是否要禁用该协议?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _disableProto({
          'protocolNo': row.protocolNo
        }).then(function (res) {
          if (res.resultCode === '0000') {
            _this9.$message({
              type: 'success',
              message: res.resultMsg
            });
          } else {
            _this9.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }

          _this9.reload();
        });
      }).catch(function () {
        _this9.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    }
  }
};